module.exports = __webpack_public_path__ + "img/arrow-dropdown.7f8b7abe.svg";